import React , { useEffect, useState , useMemo } from 'react';
// import AccessTokenCookie from 'js/Services/Auth/Model/Identity/AccessTokenCookie.js';
// import UserPerson from 'js/Services/Auth/Model/User/UserPerson.js';
import { v4 as uuidv4 } from 'uuid';
import CircularProgress from '@mui/material/CircularProgress';


import { useNavigate    } from "react-router-dom";

import AuthenticationLayout from 'js/components/page-components/AuthenticationLayout.js'; 

const useLoginToken = function( authService  ) {
    const [ loginAttempt , setLoginAttempt ] = useState(null);
    const [ userDetailsForAttemptToken , setUserDetailsForAttemptToken] = useState(null); 
    const searchParams = new URLSearchParams(window.location.search);
    const   loginToken  = useMemo(() => { 
        const getParamToken = searchParams.get('logintoken');
        if( getParamToken ){
            return getParamToken;
        }
        return null;
    });
    let navigate = useNavigate();

    

    
   
    const fetchTokenDetails = async () => {
        try {
        const response = await fetch( '/rest-api/login-init-tokens/' +  loginToken ,  {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json' ,
              'Accept': 'application/json'
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          });

          if( response.status != 200 ){
            setLoginAttempt({
                'status' : 'tokenInvalid',
                'loginToken' : loginToken , 
            }); 
            return;
          }

          const userData = await response.json(); 

          if( userData.used ){
            setLoginAttempt({
                'status' : 'tokenUsed',
                'loginToken' : loginToken , 
            }); 
            return;
          }
          setUserDetailsForAttemptToken(userData);
        } catch(e){
             setLoginAttempt({
                'status' : 'tokenInvalid',
                'loginToken' : loginToken , 
            }); 
        }
    };

    const startLoginAttempt = async () => {
        if( loginAttempt || !( userDetailsForAttemptToken && !parseInt(userDetailsForAttemptToken.used))){
            if(loginAttempt){
                alert('al in attempt');
            } else {
            }
            
            return;
        }

        setLoginAttempt({
            'status' : 'init',
            'loginToken' : loginToken , 
            'userId' : userDetailsForAttemptToken.uid  
        });

        const response = await fetch( '/rest-api/dauth/access_token'  ,  {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json' ,
              'Accept': 'application/json'
            },
            body : JSON.stringify( {
                type : 'LoginInitToken' ,
                uid : userDetailsForAttemptToken.uid ,
                hash :  loginToken  ,
            }) ,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          });

          if(response.status != 201) {
                alert('error bij login');
                setLoginAttempt({
                    'status' : 'tokenInvalid',
                    'loginToken' : loginToken , 
                    'userId' : userDetailsForAttemptToken.uid  
                }); 

                
                return;
          }

        const tokenResult = await response.json(); 


        const identity = {
            'authIdentity' : {
                userId : tokenResult.loggedInUser.id ,
                'type' : 'dauth-accesstoken' , 
                'token' :  tokenResult.token
            } , 
            'user' : {
                id : tokenResult.loggedInUser.id , 
                firstname : tokenResult.loggedInUser.firstname , 
                lastname : tokenResult.loggedInUser.lastname , 
                email:  tokenResult.loggedInUser.email , 
                managingSuppliers : tokenResult.loggedInUser.managingSuppliers 
            }
        }
        
        authService.setCurrentIdentity(identity);
        stopLoginAttempt();
    };

    const stopLoginAttempt = async () => {
        document.location =  navigate(document.location.pathname, { replace: false }); ;
    };

    
    useEffect( ()=>{
        fetchTokenDetails();
    } , []);

    if( !loginToken ){
        return null;
    }

    if( loginAttempt ){
        if( loginAttempt.status && loginAttempt.status == 'tokenInvalid'){
            return <AuthenticationLayout><div>De login token is invalid<br />
            <a href="" onClick={(e)=>{ e.preventDefault(); alert('not implemented');}}>Nieuwe token sturen</a>
                <a href="" onClick={(e)=>{ e.preventDefault(); stopLoginAttempt(); }}>Ga verder zonder login</a>
                </div></AuthenticationLayout>;
        } else if( loginAttempt.status && loginAttempt.status == 'tokenUsed'){
            return <AuthenticationLayout><div>
                Deze login token is al gebruikt. vraag een nieuwe aan <br />
                <a href="" onClick={(e)=>{ e.preventDefault(); alert('not implemented');}}>Nieuwe token sturen</a>
                <a href="" onClick={(e)=>{ e.preventDefault(); stopLoginAttempt(); }}>Ga verder zonder login</a>
            </div></AuthenticationLayout>;
        }
        return <AuthenticationLayout><div>U wordt ingelogd</div></AuthenticationLayout>;
   
    } else if( loginToken ){
        if( !userDetailsForAttemptToken ){
            return <div style={{ height:'100%' , width : '100%' , display: 'flex' , alignItems : 'center' , textAlign: 'center'}}><CircularProgress /></div>;
        }
        return <AuthenticationLayout><div>Je probeert in te loggen als { userDetailsForAttemptToken.username }. <a href="" onClick={(e)=>{ e.preventDefault(); alert('onclick');  startLoginAttempt(); }}>ga verder</a> - <a href="" onClick={(e)=>{ e.preventDefault(); stopLoginAttempt(); }} >stop</a> </div></AuthenticationLayout>;
    }

    return null;
}


export  default useLoginToken  ;